import styled, { css } from 'styled-components';
import { Icon } from 'view/atoms';
import { Colors, Filters, Media } from 'enums';
import { AlertType, AlertDTO } from 'interfaces/alert.model';
import { ZIndex } from 'config';

const PopupNotifyConf = {
  [AlertType.success]: { color: Colors.green, icon: Filters.green },
  [AlertType.error]: { color: Colors.red3, icon: Filters.red },
  [AlertType.warning]: { color: Colors.orange, icon: Filters.orange },
  [AlertType.info]: { color: Colors.blue, icon: Filters.blue },
};

type PopupNotifyProps = Pick<AlertDTO, 'type'> & { centered?: boolean };

export const PopupNotify = styled.div<PopupNotifyProps>`
  position: fixed;
  z-index: ${ZIndex.Alert};
  display: flex;
  height: min-content;
  max-width: 90%;
  width: max-content;
  min-height: 100px;
  align-items: center;
  justify-content: center;
  padding: 20px 15px;
  background-color: ${({ type }) => type && PopupNotifyConf[type].color};
  border-radius: 16px;
  box-shadow: 0px 4px 15px 4px rgba(0, 0, 0, 0.08);
  left: 50%;

  ${({ centered: isCentered }) =>
    !isCentered
      ? css`
          bottom: 25px;
          transform: translateX(-50%);
        `
      : css`
          top: 50%;
          transform: translateX(-50%) translateY(-50%);
        `}

  @media ${Media.notebook} {
    max-width: 70%;
    padding: 20px 36px;
  }
`;

export const ContentModal = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: 36px;
  width: max-content;
`;

export const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  row-gap: 8px;
`;

export const FilteredIcon = styled(Icon)<Pick<AlertDTO, 'type'>>`
  filter: ${({ type }) => type && PopupNotifyConf[type].icon};
`;

export const IconContainer = styled.div`
  height: 26px;
  width: 32px;
  border-radius: 8px;
  background-color: white;

  @media ${Media.tablet} {
    width: 26px;
  }

  @media ${Media.notebook} {
    height: 32px;
    width: 32px;
  }
`;

export const CloseButton = styled.div`
  align-self: flex-start;
  transition: opacity 0.3s ease;

  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
`;
